var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vm-modal"},[_c('iframe',{ref:"iframe",attrs:{"id":"iframeVisaMobileInfo","src":_vm.getVisaMobileInfoIframeSrc(),"title":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }